import {Box,ButtonGroup,Button,Stack,Tooltip} from '@mui/material';
import MethodButtonRows,{getVisibleMethodGroups} from './MethodButtonRows';
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveIcon from '@mui/icons-material/Remove';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const DetailForm=({renderPageHeader,readOnly,recordRules,handleClickEvent,recordInfo={show:false,errorLog:false},renderedFieldsBefore,renderButtonShowMoreInfo,recordId,showMoreInfo,renderedFieldsAfter,renderPageDetailTabs,application,handleClickMethodButton,isChanged,hideParent=false,renderedFormAside})=>{
    const hasMoreInfo=Array.isArray(renderedFieldsAfter)&&renderedFieldsAfter.some(Boolean);
    const canEdit=recordRules?.can_update_record===true;
    const canDelete=recordRules?.can_delete_record===true;
    
    return (
        <div className="page">
            {!hideParent&&renderPageHeader()}
            {!hideParent&&
            <div className="page-content">
                <Box component="form" noValidate autoComplete="off">
                    <MethodButtonRows
                        sx={{pb:1}}
                        methodGroups={getVisibleMethodGroups(recordRules,readOnly)}
                        handleClickMethodButton={handleClickMethodButton}
                        application={application}
                        mainButtons={(
                        /* MAIN BUTTONS */
                        <ButtonGroup size="small" sx={{minHeight:24,'& .MuiButton-root':{whiteSpace:'nowrap'}}}>
                            {readOnly&&canEdit&&(<Button variant="outlined" onClick={()=>handleClickEvent({action:'update'})}>{application.getLocale("ButtonUpdate")}</Button>)}
                            {readOnly&&canDelete&&(
                                <Button 
                                    color="error"
                                    variant="outlined" 
                                    sx={{display:'flex','& .MuiButton-startIcon':{marginRight:0,},ml:'0px',alignItems:'center',justifyContent:'center',}}
                                    startIcon={<RemoveIcon />}
                                    onClick={()=>handleClickEvent({action:'delete'})}>
                                </Button>
                            )}
                            {!readOnly&&(<Button disabled={!isChanged} variant={isChanged?"contained":"outlined"} onClick={()=>handleClickEvent({action:'save'})}>{application.getLocale("ButtonSave")}</Button>)}
                            {!readOnly&&(<Button variant="outlined" onClick={()=>handleClickEvent({action:'cancel'})}>{application.getLocale("ButtonCancel")}</Button>)}
                            {readOnly&&(
                                <Tooltip title={application.getLocale("ButtonRefresh")}>
                                    <Button
                                        startIcon={<RefreshIcon />}
                                        variant="outlined"
                                        sx={{
                                            minWidth:32,
                                            padding:0,
                                            "& .MuiButton-startIcon":{margin:0},}}
                                        onClick={()=>handleClickEvent({action:'refresh'})}/>
                                </Tooltip>
                            )}
                            {readOnly&&recordInfo.show&&(
                                <Tooltip title={application.getLocale("ButtonRecordInfo")}>
                                    <Button
                                        startIcon={<InfoOutlinedIcon />}
                                        variant="outlined"
                                        sx={{
                                            minWidth:32,
                                            padding:0,
                                            "& .MuiButton-startIcon":{margin:0},}}
                                        onClick={()=>handleClickEvent({action:'open_record_info',errorLog:recordInfo.errorLog})}/>
                                </Tooltip>
                            )}
                        </ButtonGroup>
                        )}/>
                    {renderedFormAside?(
                        //optional client block (e.g. a picture) left of the first lines - above them on phones
                        <Stack direction={{xs:'column',sm:'row'}} spacing={{xs:1,sm:2}} sx={{alignItems:'flex-start'}}>
                            <Box sx={{flexShrink:0}}>{renderedFormAside}</Box>
                            <Box sx={{flex:1,minWidth:0,width:'100%'}}>{renderedFieldsBefore}</Box>
                        </Stack>
                    ):renderedFieldsBefore}
                    {recordId&&hasMoreInfo&&renderButtonShowMoreInfo()}
                    {(showMoreInfo||!recordId)&&renderedFieldsAfter}
                </Box>
            </div>}
            {hideParent&&renderPageDetailTabs()}
            {recordId&&renderPageDetailTabs()}
        </div>
    );
}

export default DetailForm;
